import { type ReactNode } from 'react';

interface FloatingTextboxProps {
  children: ReactNode;
  top?: string;
  text?: ReactNode | null;
}

const FloatingTextbox = ({ children, top = '1.5rem', text = null }: FloatingTextboxProps) => (
  <span className="position-relative opacity-transition-anchor">
    {children}
    {text && (
      <span
        className="bg-text opacity-0 opacity-transition pointer-events-none position-absolute px-2 py-1 radius-0_125 right-0 text-white text-0_75 z-2"
        style={{ top }}
      >
        {text}
      </span>
    )}
  </span>
);

export default FloatingTextbox;
